export const heads = [
  {
    key: 'parentName',
    name: 'Name',
    sortable: false,
    filterable: false,
    capitalize: true,
    className: 'clients-parent-column',
  },
  {
    key: 'petName',
    name: 'Pet Name',
    sortable: false,
    filterable: false,
    capitalize: true,
    className: 'clients-pet-column',
  },
  {
    key: 'speciesName',
    name: 'Species',
    sortable: false,
    filterable: false,
    capitalize: true,
    className: 'clients-species-column',
  },
  {
    key: 'breedName',
    name: 'Breed',
    sortable: false,
    filterable: false,
    capitalize: true,
    className: 'clients-breed-column',
  },
  {
    key: 'gender',
    name: 'Gender',
    sortable: false,
    filterable: false,
    capitalize: true,
    className: 'clients-gender-column',
  },
  {
    key: 'phone',
    name: 'Mobile Number',
    sortable: false,
    filterable: false,
    capitalize: false,
    className: 'clients-mobile-column',
  },
];
